export const LOGIN = `login`;
export const LOGIN_SUCCESS = `${LOGIN}.success`;
export const LOGIN_FAILED = `${LOGIN}.failed`;
export const LOGIN_RESET = `${LOGIN}.reset`;

